import { defaultIntegrationContactObject, defaultIntegrationMeetingExportObject, IntegrationServiceId } from '../../../../../common/integrations'
import { CRMAccountIntegrationConfig } from '../../../../../models/Account'

export const defaultCRMAccountIntegrationConfig = (serviceId: IntegrationServiceId): CRMAccountIntegrationConfig => {
  const contactObject = defaultIntegrationContactObject[serviceId]
  const meetingExportObject = defaultIntegrationMeetingExportObject[serviceId]
  if (contactObject && meetingExportObject) {
    return {
      type: 'crm',
      serviceId,
      loginUrl: null,
      mappings: { contact: { objectName: contactObject }, session: { objectName: meetingExportObject.id } },
      enableNoteExport: true,
      enableFullMeetingExport: true,
      isCustom: false,
      isSyncDisabled: false,
    }
  }
  return {
    type: 'crm',
    serviceId,
    loginUrl: null,
    mappings: {},
    enableNoteExport: true,
    enableFullMeetingExport: true,
    isCustom: false,
    isSyncDisabled: false,
  }
}
